import withTestId from './withTestId';

const withLocator = (
  base?: string,
  block_name?: string,
  element_name?: string
) => {
  let locator = [base, block_name].filter(Boolean).join('_'); // Join base and block normally

  if (element_name) {
    locator += `__${element_name}`; // Add double underscore before the element
  }

  return withTestId(locator);
};

export default withLocator;
